<template>
<v-content class="spinelab-website-front">
  <v-container fluid>
    <v-dialog v-model="tiDialog">
      <v-card class="spinelab-website-front">
        <v-card-title primary-title>
          <h3 class="headline mb-0">テンプレートから選択</h3>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogue()">
            キャンセル
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="confirmTemplateImage()"
                 color="success"
                 :disabled="!('s3_file_id' in selectedTI)">
            この画像を使用する
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex xs2 md2 xl2
                    v-for="image in tiImages"
                    :key="image.s3_file_id">
              <v-card flat tile>
                <v-card-media
                  :src="image.s3_file_url"
                  height="80px"
                  @click="selectTemplateImage(image)"
                  :class="{ [$style['selected-card']]: image.s3_file_id == selectedTI.s3_file_id }">
                </v-card-media>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogue()">
            キャンセル
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="confirmTemplateImage()"
                 color="success"
                 :disabled="!('s3_file_id' in selectedTI)">
            この画像を使用する
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
   </v-dialog>
    <v-layout row>
      <v-flex xs10 sm10 md10>
        <h1 class="text-sm-left">基本情報</h1>
      </v-flex>
      <v-flex xs2 sm2 md2>
        <v-btn href="static/pdf/manual.pdf" target="_blank" color="warning">
          ご利用ガイド
        </v-btn>
      </v-flex>
    </v-layout>
    <v-tabs
       centered
       v-model="tab">
      <v-tab
         v-for="tabInfo in siteInfo"
         :key="tabInfo.tab_label"
         :href="`#tab-${tabInfo.tab_label}`">
        {{ tabInfo.tab_label }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
         v-for="tabInfo in siteInfo"
         :key="tabInfo.tab_label"
         :id="`tab-${tabInfo.tab_label}`">
        <template v-for="info in tabInfo.informations">
          <v-layout
             :key="info.m_information_id"
             :row="['textarea', 'wysiwyg'].indexOf(info.editor) !== -1">
            <v-flex md4 v-if="info.editor !== 'textarea'">
              <v-subheader>
                <p :title="`タグ: \{\{*${info.key}*\}\}`">
                  {{info.key}}
                </p>
                <v-spacer/>
                <p class="text-sm-left" v-if="info.editor === 'wysiwyg'">
                  ※ファイルサイズ上限 2MB
                </p>
              </v-subheader>
              <v-subheader class="text-sm-left" v-if="info.key === '一言案内'">
                <a href="static/pdf/phrases.pdf" target="_blank">キャッチコピーのサンプルはこちら</a>
              </v-subheader>
            </v-flex>
            <v-flex md8 v-if="info.editor === 'input-text'">
              <v-text-field
                v-model="info.content">
              </v-text-field>
              <span v-if="info.key === 'E-mailアドレス'" class="caption">
                ※サイトの「お問い合わせ」に問い合わせが入った場合の通知先メールアドレスは別途「お問い合わせの管理」>「設定」>「通知先のメールアドレス」にご入力ください。<br>
                ※サイト上にメールアドレスを表示させると迷惑メールが入る恐れがありますので問い合わせフォームの活用をお勧めしています。
              </span>
            </v-flex>
            <v-flex md8 v-if="info.editor === 'image'">
              <v-layout row align-left>
                <v-flex md2>
                  <div :class="$style.box" v-if="info.imageLoading">
                    <v-progress-circular indeterminate
                                         :size="70"
                                         :width="7"
                                         color="orange">
                    </v-progress-circular>
                  </div>
                  <img :src="info.s3_file_url" :class="$style.box"
                       v-else-if="info.s3_file_url !== null"/>
                  <div :class="`${$style.box} ${$style.grey}`" v-else></div>
                </v-flex>
                <v-flex md6>
                  <v-layout row>
                    <v-btn @click="clickInputFile(info.m_information_id)">
                    画像ファイルを選択
                    </v-btn>
                    <form :id="`upload-${info.m_information_id}-form`">
                      <input
                        type="file"
                        :id="`upload-${info.m_information_id}`"
                        @change="filesChange(info, $event.target.files)"
                        accept="image/png,image/jpeg"
                        style="display:none">
                    </form>
                    <template v-if="info.s3_file_url !== null">
                      <v-spacer />
                      <v-btn @click="removeImage(info)"
                             block
                             color="error">
                        削除
                      </v-btn>
                    </template>
                  </v-layout>
                  <v-btn @click="showTemplateImages(info, false)"
                         v-if="info.key === 'トップページメイン画像'">
                    テンプレートから画像を選択
                  </v-btn>
                  <v-btn @click="showTemplateImages(info, true)"
                         v-else-if="['事業内容画像１', '事業内容画像２', '事業内容画像３'].indexOf(info.key) !== -1">
                    テンプレートから画像を選択
                  </v-btn>
                  <p class="text-sm-left" v-if="info.notes">
                    {{info.notes}}
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md8 v-if="info.editor === 'select-option'">
              <v-select
                 :items="info.options.select_options"
                 v-model="info.content"
                 single-line
                 ></v-select>
            </v-flex>
            <v-flex md8 v-if="info.editor === 'color-theme'">
              <v-btn-toggle
                 v-model="info.content">
                <v-btn v-for="op in info.options.select_options"
                       :key="op"
                       :style="`background-color: ${op.toLowerCase()};`"
                       :value="op">
                  <p style="color: white;"
                     :class="{ [$style.bold]: info.content === op }">
                    {{op}}
                  </p>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
          <v-layout v-if="info.editor === 'textarea'"
                    :key="`'textarea'-${info.m_information_id}`"
                    row>
            <v-flex md12>
              <v-text-field
                 v-model="info.content"
                 :label="info.key"
                 :title="`タグ: \{\{*${info.key}*\}\}`"
                 textarea
                 rows="10"
                 ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-else-if="info.editor === 'wysiwyg'"
                    :key="`'wysiwyg'-${info.m_information_id}`"
                    row>
            <v-flex md12 :class="$style.quillEditorWrap">
              <quill-editor
                :content.sync="info.content"
                :class="$style.quillEditor"
                :options="editorOption"
              >
              </quill-editor>
            </v-flex>
          </v-layout>
        </template>
        <v-btn @click="save(tabInfo)"
               color="success"
               :loading="loading">
          保存
        </v-btn>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</v-content>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';

import { uploadToS3 } from '@/utils/Requests';
import QuillEditor from './QuillEditor';

const successSave = '基本情報の変更を保存しました';
const typeMessage = 'png形式またはjpeg形式の画像を選択してください';
const sizeMessage = '2MB以下のサイズの画像を選択してください';

export default {
  name: 'BasicInformation',
  components: {
    quillEditor: QuillEditor,
  },
  data() {
    return {
      tab: '',
      loading: false,
      templateImages: [],
      businessTemplateImages: [],
      tiDialog: false,
      tiInfo: {},
      tiIsBusiness: false,
      selectedTI: {},
      editorOption: {
        modules: {
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: [
              'Resize',
              'DisplaySize',
            ],
          },
          toolbar: [
            [{ size: ['14px', '16px', '20px', '32px'] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { color: [] },
              { background: [] },
            ],
            ['link', 'image'],
            ['clean'],
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      requests: state => state.requests,
      siteId: state => state.siteId,
      siteInfo: state => state.siteInformation,
    }),
    tiImages() {
      return this.tiIsBusiness ? this.businessTemplateImages : this.templateImages;
    },
  },
  methods: {
    ...mapActions(['postSiteInformation', 'showAlert']),
    async showTemplateImages(info, isBusiness) {
      this.tiIsBusiness = isBusiness;
      this.tiDialog = true;
      this.tiInfo = info;
      if (info.s3_file_id && info.s3_file_url) {
        this.selectedTI = this.tiImages.find(
          ti => ti.s3_file_id === info.s3_file_id)
          || {};
      } else {
        this.selectedTI = {};
      }
    },
    async selectTemplateImage(image) {
      this.selectedTI = image;
    },
    async cancelDialogue() {
      this.tiDialog = false;
    },
    async confirmTemplateImage() {
      this.tiDialog = false;
      if (!this.selectedTI.s3_file_id || !this.selectedTI.s3_file_url) {
        return;
      }
      Vue.set(this.tiInfo, 's3_file_id', this.selectedTI.s3_file_id);
      Vue.set(this.tiInfo, 's3_file_url', this.selectedTI.s3_file_url);
    },
    async save() {
      this.loading = true;
      const result = await this.postSiteInformation();
      if (result) {
        this.showAlert({ message: successSave, type: 'success' });
      } else {
        this.showAlert({ message: undefined, type: 'error' });
      }
      this.loading = false;
    },
    clickInputFile(id) {
      document.getElementById(`upload-${id}`).click();
    },
    async filesChange(info, files) {
      Vue.set(info, 'imageLoading', true);
      const file = files[0];
      document.getElementById(`upload-${info.m_information_id}-form`).reset();
      if (!file) {
        Vue.set(info, 'imageLoading', false);
        return;
      }
      const { type, size } = file;
      if (type !== 'image/png' && type !== 'image/jpeg') {
        Vue.set(info, 'imageLoading', false);
        this.showAlert({ message: typeMessage, type: 'warning' });
        return;
      }
      if (size > 2 * 1024 * 1024) {
        Vue.set(info, 'imageLoading', false);
        this.showAlert({ message: sizeMessage, type: 'warning' });
        return;
      }
      const urlData = await this.requests.getS3UploadURL(this.siteId);
      const s3URL = urlData.put_presigend_url;
      const s3FileId = urlData.s3_file_id;
      const data = await uploadToS3(s3URL, file);
      if (!data) {
        Vue.set(info, 'imageLoading', false);
        this.showAlert({ message: undefined, type: 'error' });
        return;
      }
      const imgURL = await this.requests.postS3Upload(this.siteId, s3FileId);
      if (!imgURL) {
        Vue.set(info, 'imageLoading', false);
        this.showAlert({ message: undefined, type: 'error' });
        return;
      }
      Vue.set(info, 'imageLoading', false);
      Vue.set(info, 's3_file_id', s3FileId);
      Vue.set(info, 's3_file_url', imgURL);
    },
    async removeImage(info) {
      Vue.set(info, 's3_file_id', null);
      Vue.set(info, 's3_file_url', null);
    },
  },
  async created() {
    const result = await Promise.all([
      this.requests.getTemplateImages(),
      this.requests.getBusinessTemplateImages(),
    ]);
    if (result[0]) {
      this.templateImages = result[0].map(i => ({
        s3_file_id: i.s3_file_id,
        s3_file_url: i.s3_file_url,
      }));
    }
    if (result[1]) {
      this.businessTemplateImages = result[1].map(i => ({
        s3_file_id: i.s3_file_id,
        s3_file_url: i.s3_file_url,
      }));
    }
  },
};
</script>

<style module>
.box {
  max-width: 100px;
  height: 90px;
  margin: 5px;
}
.grey {
  background: #D3D3D3;
}

.bold {
   font-weight: bold !important;
}
.quillEditor {
    height: 15em;
}
.quillEditorWrap {
    height: 19em;
}
.selected-card {
  border: 8px solid green;
}
</style>



// WEBPACK FOOTER //
// src/components/BasicInformation.vue